__turbopack_context__.v({
  "codeBlock": "DebugAiNotesPanel-module__NvRmma__codeBlock",
  "codeBlockSoftWrap": "DebugAiNotesPanel-module__NvRmma__codeBlockSoftWrap",
  "debugBody": "DebugAiNotesPanel-module__NvRmma__debugBody",
  "debugHeader": "DebugAiNotesPanel-module__NvRmma__debugHeader",
  "debugHeaderActions": "DebugAiNotesPanel-module__NvRmma__debugHeaderActions",
  "debugPanel": "DebugAiNotesPanel-module__NvRmma__debugPanel",
  "debugSection": "DebugAiNotesPanel-module__NvRmma__debugSection",
  "debugSummary": "DebugAiNotesPanel-module__NvRmma__debugSummary",
  "payloadHeaderRow": "DebugAiNotesPanel-module__NvRmma__payloadHeaderRow",
  "payloadHeaderRowAfterSystemMessage": "DebugAiNotesPanel-module__NvRmma__payloadHeaderRowAfterSystemMessage",
});
